module.exports = __webpack_public_path__ + "static/logo-gandd-a0bc8141f52e175d39194e27a84e3851.webp";